'use strict';
angular.module('resCenterWebSiteRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.classifiedresource.website.resource', {
                url: '/resource?acode&fcode&is_host_site&flag&media_id&hybase_id&param_data&medianame',
                views: {
                    'networksource@front.networksource.classifiedresource.website': {
                        templateUrl: './networkResource/classifiedResource/website/main_tpl.html',
                        controller: 'resWebsiteMainCtrl',
                    },
                },
            })
            .state('front.networksource.classifiedresource.website.quickpreview', {
                url: '/quickpreview?acode&fcode&is_host_site&flag&media_id&hybase_id&param_data&guid',
                views: {
                    'networksource@front.networksource.classifiedresource.website': {
                        templateUrl: './networkResource/classifiedResource/website/quickPreview/main_tpl.html',
                        controller: 'websiteQuickPreviewCtrl',
                    },
                },
            });
    },
]);
